/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Hospital {
  /** 병원의 정식 명칭 */
  name?: string;
  /** 사용자에게 보여질 병원명 */
  shortName?: string;
  /** 병원 주소 */
  address?: string;
  /** 병원 주소체계 검색 및 지도용 주소 정보 */
  addressInfo?: Record<string, any>;
  /** 네이버 지도 API 사용을 위한 주소 정보 */
  addressInfoNaver?: Record<string, any>;
  /** 병원의 진료과 ID 목록 */
  department?: string[];
  /** 병원 소개 글 */
  introduction?: string;
  /** 병원 정보 페이지에 노출될 이미지 파일 ID */
  representImage?: RepresentImage;
  /** 대표 원장님 ID */
  representUser?: string;
  /** 병원 홈페이지 URL */
  homepageURL?: string;
  /** 병원 전화번호 */
  phone?: string;
  /** 병원 전화번호 숨김 여부 */
  isHiddenPhoneNumber?: boolean;
  /** 병원 홈페이지/전화번호 사용 여부. true - 홈페이지 사용, false - 전화번호 사용 */
  usingHomepage?: boolean;
  /** 초기 채팅 발송 문구 (deprecated) */
  initialChat?: string[];
  /** 다양한 타입을 지원하는 초기 채팅 발송 문구 목록 */
  initialChats?: {
    /** 채팅 타입 */
    chatType?: number;
    /** 채팅 내용 */
    content?: string;
    /** 첨부 파일 ID 목록 */
    fileIDs?: string[];
  }[];
  /** 환자 관리를 위해 매니저가 사용할 ServiceFlagCategory 의 기본값 ID */
  defaultFlag?: string;
  /** 1차 프로덕트에서 사용된 치료 목록 */
  therapyList?: string[];
  /** 서비스 매니저가 병원에 대한 특이사항을 기록하기 위한 JSON 객체 */
  additionalInfo?: Record<string, any>;
  /** 문자 유입 프로세스에서 기본 메시지 발송 여부 (deprecated) */
  isBasicMessage?: boolean;
  /** 문자 유입 시 발송될 기본 문구 (deprecated) */
  smsMessage?: string;
  /** A/B 테스트를 위한 메시지 문구 A (deprecated) */
  smsMessageA?: string;
  /** A/B 테스트를 위한 메시지 문구 B (deprecated) */
  smsMessageB?: string;
  /** 자동 발송될 기본 채팅 메시지 (deprecated) */
  smsChatMessage?: string;
  /** A/B 테스트를 위한 초기 채팅 메시지 A (deprecated) */
  smsChatMessageA?: string;
  /** A/B 테스트를 위한 초기 채팅 메시지 B (deprecated) */
  smsChatMessageB?: string;
  /** 고객 등록 시 가입 문자 직접 입력 설정 여부. 기본 문구 사용 시 true */
  usingBasicMessage?: boolean;
  /** 고객 등록 시 가입 문자 기본 문구 */
  smsBasicMessage?: string;
  /** 고객 등록 시 가입 문자 직접 입력 문구. [병원 설정 > 등록 문자 관리 > 고객 등록 시 가입 문자] 메뉴의 '직접 입력' 값 */
  smsBasicMessageEdit?: string;
  /** 예약 등록 시 가입 문자 직접 입력 설정 여부. 기본 문구 사용 시 true */
  usingReservationMessage?: boolean;
  /** 예약 등록 시 가입 문자 기본 문구 */
  smsReservation?: string;
  /** 예약 등록 시 가입 문자 직접 입력 문구. [병원 설정 > 등록 문자 관리 > 예약 등록 시 가입 문자] 메뉴의 '직접 입력' 값 */
  smsReservationEdit?: string;
  /** 기존 고객 가입 문자 재발송 직접 입력 설정 여부. 기본 문구 사용 시 true */
  usingResendMessage?: boolean;
  /** 기존 고객 가입 문자 재발송 기본 문구 */
  smsResendMessage?: string;
  /** 기존 고객 가입 문자 재발송 직접 입력 문구. [병원 설정 > 등록 문자 관리 > 기존 고객 가입 문자 재발송] 메뉴의 '직접 입력' 값 */
  smsResendMessageEdit?: string;
  /** 채팅 예약 발송 시 커스텀 메시지. 값이 없을 경우 서버에서 하드코딩된 기본값 발송 */
  chatReservationGuide?: string;
  /** 진료 시간 */
  careSchedule?: {
    /** 요일 인덱스 (0 - 일요일, 1 - 월요일, ...) */
    dayIndex?: number;
    /**
     * 진료 시작 시간
     * @format date-time
     */
    startedAt?: string;
    /**
     * 진료 종료 시간
     * @format date-time
     */
    endedAt?: string;
    isActive?: boolean;
  }[];
  /** 진료 시간 설명 */
  careScheduleDescription?: string;
  /** 문자 유입에 사용할 이미지 파일 ID */
  smsLogoImage?: string;
  /** 문자 유입 시 이미지 사용 여부 */
  isUsingLogo?: boolean;
  /** 담당 서비스 매니저의 User ID */
  nurseID?: Nurse;
  /** 병원별 여러 명의 서비스 매니저를 담기 위한 서비스 매니저 User ID 목록 */
  nurseIDs?: string[];
  /** 담당 서비스 매니저가 여러 명인지 단일인지 구분하는 플래그. "single" 또는 "network" */
  hospitalType?: string;
  /** 문자 유입 사용 여부 플래그 */
  usingRegistUser?: boolean;
  /** 서비스 진행 여부 플래그 */
  isClosed?: boolean;
  /** 서비스 설정 모델 ID */
  serviceSetting?: string;
  /** 현재 모바일에서 예약 가능한 시트가 존재하는지 확인하는 플래그 */
  hasActiveSheet?: boolean;
  /** 2차 프로덕트 사용 여부 */
  isSecondEdition?: boolean;
  /** 홈케어 콘텐츠 모듈 사용 여부 */
  usingVideoContent?: boolean;
  /** 병원 이벤트 모듈 사용 여부 */
  usingHospitalEvent?: boolean;
  /** 모바일 홈 화면에 표시될 건강 관리 뉴스 카테고리. 빈 배열일 경우 기본값 (모든 카테고리, createdAt -> -1) 사용 */
  healthContentCategory?: string[];
  /** 건강 콘텐츠 사용 여부 */
  usingHealthContent?: boolean;
  /** 병원 소식 사용 여부 */
  usingHospitalContent?: boolean;
  /** 연동 설정 모델 ID */
  integrationSetting?: string;
  /** 애프터닥 운영 시간 종료 후 환자 채팅 시 팝업 표시 여부 */
  usingAfterhoursPopup?: boolean;
  /** 애프터닥 운영 시간 종료 후 환자 채팅 시 표시할 팝업 내용. HTML 태그 형태로 포함 가능 */
  afterhoursPopupContent?: string;
  /** 자동 가입 문자 재발송 사용 여부 */
  usingAutoReservedSMS?: boolean;
  /** 자동 재가입 문자 발송에 사용될 콘텐츠 */
  autoReservedSMSMessage?: string;
  /** 자동 재가입 문자 발송까지 대기할 일 수 */
  autoReservedSMSDelayDay?: number;
  /** 자동 재가입 문자가 발송될 시간 */
  autoReservedSMSHour?: number;
  /** 예약 시트 2차 버전 사용 여부 */
  usingV2ReservationSheet?: boolean;
  /** SaaS 예약시트 사용 여부 */
  usingSaaSReservation?: boolean;
  /** SaaS 활성화 여부. true - 활성화, false - 비활성화 => 레거시 애프터닥 사용 버전 */
  isEnabledSaaS?: boolean;
  /**
   * 생성일
   * @format date-time
   */
  createdAt?: string;
  /**
   * 마지막 수정일
   * @format date-time
   */
  updatedAt?: string;
  /** 병원 ID */
  _id?: string;
  /**
   * SaaS 용 추가 파라미터 - 테스트 병원 여부
   * @default false
   */
  isTest: boolean;
  /** SMS 발신용 전화번호 */
  smsPhone?: string;
  /** 병원 별 언어와 국가 설정. 예: ko-KR (한국어, 대한민국), en-US (영어, 미국), vn-VN (베트남어, 베트남) */
  locale?: string;
  /** 병원 별 시간대 설정. 예: Asia/Seoul (서울), Asia/Ho_Chi_Minh (호치민) */
  timezone?: string;
  /** 이 병원이 다중병원(MSO) 그룹에 소속돼 있는지 여부 */
  isMso?: boolean;
}

export interface RepresentImage {
  /** 이미지 파일 ID */
  _id?: string;
  /** 이미지 파일 소유자 ID */
  userID?: string;
  /** 파일 타입. 300 - 이미지, 400 - 비디오, 500 - 파일 */
  type?: number;
  /** 이미지 URL 배열 */
  paths?: string[];
  aws?: {
    /** S3에 저장된 이미지 URL */
    Location?: string;
    /** S3 버킷 이름 */
    Bucket?: string;
    /** S3 객체 키 */
    Key?: string;
    /** S3 ETag 값 */
    ETag?: string;
    size?: {
      /** 이미지 너비 */
      width?: number;
      /** 이미지 높이 */
      height?: number;
    };
    /** 파일 크기 (byte) */
    fileSize?: number;
    /** 파일 이름 */
    fileName?: string;
  }[];
  /**
   * 생성 시간
   * @format date-time
   */
  createdAt?: string;
  /**
   * 수정 시간
   * @format date-time
   */
  updatedAt?: string;
}

export interface Nurse {
  /** 간호사 전화번호 */
  phone?: string;
  /** 방문 정보 */
  visit?: string;
  /** 상태 정보 */
  status?: string;
  /** 기기 토큰 목록 */
  deviceTokens?: string[];
  /** 병원 서비스 목록 */
  hservices?: string[];
  /** 병원 ID 목록 */
  hospitalID?: string[];
  /** 초기 설정 필요 여부 */
  needInitial?: boolean;
  /** AfterDoc 사용 여부 */
  isAfterDoc?: boolean;
  /** 퇴사 여부 */
  isLeave?: boolean;
  /** 의사 여부 */
  isDoctor?: boolean;
  /** 사용자 등록 권한 */
  auth_regist_user?: boolean;
  /** 대시보드 열람 권한 */
  canReadDashboard?: boolean;
  /** 간호사 ID */
  _id?: string;
  /** 간호사 아이디 */
  id?: string;
  /** 간호사 이름 */
  name?: string;
  /** 간호사 소개 */
  introduction?: string;
  /** 간호사 경력 */
  career?: string;
  /** 간호사 유형 */
  type?: number;
  /** 사진 ID */
  photo?: string;
  /**
   * 생성 시간
   * @format date-time
   */
  createdAt?: string;
  /**
   * 수정 시간
   * @format date-time
   */
  updatedAt?: string;
  /** 기기 정보 */
  deviceInfos?: Record<string, any>;
  /**
   * 마지막 로그인 시간
   * @format date-time
   */
  lastLogin?: string;
}

export interface ApiResponse {
  /**
   * 응답 코드 (0=성공, 그 외=오류)
   * @default 0
   */
  code: number;
  /** 응답 데이터 */
  data: Record<string, any>;
  /** 응답 메시지. 응답 코드가 0이 아닌 경우 오류 메시지. */
  message: string;
}

export interface HospitalRepresentImage {
  /** 병원의 정식 명칭 */
  name?: string;
  /** 사용자에게 보여질 병원명 */
  shortName?: string;
  /** 병원 주소 */
  address?: string;
  /** 병원 주소체계 검색 및 지도용 주소 정보 */
  addressInfo?: Record<string, any>;
  /** 네이버 지도 API 사용을 위한 주소 정보 */
  addressInfoNaver?: Record<string, any>;
  /** 병원의 과 ID */
  department?: any[];
  /** 병원 소개 글 */
  introduction?: string;
  /** 병원 정보페이지에 노출 될 이미지 파일 ID */
  representImage?: File;
  /** 대표 원장님 */
  representUser?: string;
  /** 병원의 홈페이지 URL */
  homepageURL?: string;
  /** 병원 전화번호 */
  phone?: string;
  /** 병원 전화번호 숨김 여부 */
  isHiddenPhoneNumber?: boolean;
  /** 병원 홈페이지 / 전화번호 사용여부 */
  usingHomepage?: boolean;
  /** 초기 채팅 발송 문구 */
  initialChat?: any[];
  /** 초기 채팅 발송 문구 (텍스트 및 이미지) */
  initialChats?: any[];
  /** 환자 관리를 위해서 매니저가 사용할 ServiceFlagCategory의 디폴트 값 아이디 */
  defaultFlag?: string;
  /** 1차 프로덕트에서 사용된 치료 목록 */
  therapyList?: any[];
  /** 서비스 매니저측에서 병원에 대한 특이사항을 기록하기 위한 JSON Object. */
  additionalInfo?: Record<string, any>;
  /** 문자유입 프로세스 내에서 기본 메세지 발송 여부 플래그 */
  isBasicMessage?: boolean;
  /** 문자유입 시 발송될 기본 문구 */
  smsMessage?: string;
  /** AB 테스트를 위한 메세지 문구 A */
  smsMessageA?: string;
  /** AB 테스트를 위한 메세지 문구 B */
  smsMessageB?: string;
  /** 자동 발송될 기본 채팅 메세지 */
  smsChatMessage?: string;
  /** AB 테스트를 위한 초기 채팅 메세지 A */
  smsChatMessageA?: string;
  /** AB 테스트를 위한 초기 채팅 메세지 B */
  smsChatMessageB?: string;
  /** 고객등록시 가입 문자 직접입력 설정 여부 */
  usingBasicMessage?: boolean;
  /** 고객등록시 가입 문자 기본 문구 */
  smsBasicMessage?: string;
  /** 고객등록시 가입 문자 직접 입력 문구 */
  smsBasicMessageEdit?: string;
  /** 예약등록시 가입 문자 직접입력 설정 여부 */
  usingReservationMessage?: boolean;
  /** 예약등록시 가입 문자 기본 문구 */
  smsReservation?: string;
  /** 예약등록시 가입 문자 직접 입력 문구 */
  smsReservationEdit?: string;
  /** 기존 고객 가입 문자 재발송 직접입력 설정 여부 */
  usingResendMessage?: boolean;
  /** 기존 고객 가입 문자 재발송 기본 문구 */
  smsResendMessage?: string;
  /** 기존 고객 가입 문자 재발송 직접 입력 문구 */
  smsResendMessageEdit?: string;
  /** 채팅 예약 발송 시 커스텀 메시지 */
  chatReservationGuide?: string;
  /** 진료 시간 */
  careSchedule?: any[];
  /** 진료 시간 설명 */
  careScheduleDescription?: string;
  /** 문자 유입내 사용할 이미지 파일 ID */
  smsLogoImage?: string;
  /** 문자유입간 이미지의 사용 여부 */
  isUsingLogo?: boolean;
  /** 담당 서비스매니저의 UserID */
  nurseID?: string;
  /** 병원별 여러명의 서비스 매니저를 담기 위한 서비스매니저의 User ID 배열 */
  nurseIDs?: any[];
  /** 담당 서비스 매니저가 여럿인지, 단일이지 구분짓기 위한 플래그 */
  hospitalType?: string;
  /** 문자 유입 사용여부 플래그 */
  usingRegistUser?: boolean;
  /** 서비스 진행 여부 플래그 */
  isClosed?: boolean;
  /** 서비스 설정 모델 ObjectId */
  serviceSetting?: string;
  /** 현재 모바일에서 예약가능한 시트가 존재하는지 확인하기 위한 플래그 */
  hasActiveSheet?: boolean;
  /** 2차 프로덕트 사용여부. */
  isSecondEdition?: boolean;
  /** 홈케어 콘텐츠 모듈 사용 여부 */
  usingVideoContent?: boolean;
  /** 병원 이벤트 모듈 사용여부 */
  usingHospitalEvent?: boolean;
  /** 모바일 홈화면에 표시될 건강 관리 뉴스 카테고리. */
  healthContentCategory?: any[];
  /** 건강콘텐츠 사용 여부 */
  usingHealthContent?: boolean;
  /** 병원 소식 사용 여부 */
  usingHospitalContent?: boolean;
  /** 연동 설정 모델 ObjectId */
  integrationSetting?: string;
  /** 애프터닥 운영시간 종료 후 환자 채팅 시, 팝업 표시 여부 */
  usingAfterhoursPopup?: boolean;
  /** 애프터닥 운영시간 종료 후 환자 채팅 시, 표시할 팝업 내용 */
  afterhoursPopupContent?: string;
  /** 자동 가입문자 재발송 사용 여부 */
  usingAutoReservedSMS?: boolean;
  /** 자동 재가입 문자 발송에 사용될 콘텐츠 */
  autoReservedSMSMessage?: string;
  /** 자동 재가입 문자 발송까지 대기할 날 */
  autoReservedSMSDelayDay?: number;
  /** 자동 재가입 문자가 발송될 시간 */
  autoReservedSMSHour?: number;
  /** 예약 시트 2차 버전 사용 여부 */
  usingV2ReservationSheet?: boolean;
  /** SaaS 예약시트 사용 여부 */
  usingSaaSReservation?: boolean;
  /** SaaS 프로덕트 사용 여부 */
  isEnabledSaaS?: boolean;
  /** 병원 별 언어와 국가 설정. 예: ko-KR (한국어, 대한민국), en-US (영어, 미국), vn-VN (베트남어, 베트남) */
  locale?: string;
  /** 병원 별 시간대 설정. 예: Asia/Seoul (서울), Asia/Ho_Chi_Minh (호치민) */
  timezone?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface File {
  /**
   * 파일 ID
   * @example "66aca461f8238a4fd30abe15"
   */
  _id: string;
  /** 파일의 소유자 ID */
  userID?: string;
  /**
   * 파일 타입
   * - 300: Image
   * - 400: Video
   * - 500: File
   */
  type: number;
  /** 파일 객체에 포함된 파일의 URL 배열 */
  paths: string[];
  /** 파일 별, S3 스토리지에 업로드 된 파일의 정보 객체 배열 */
  aws?: Record<string, any>[];
  /** 파일 만료일. 외부 연동 서비스일 경우에 존재 */
  expiredAt?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface CommonResponse {
  /** 오류 메시지 (정상="정상") */
  errorMessage?: string;
  /** 페이지당 결과 개수 */
  countPerPage?: string;
  /** 전체 결과 개수 */
  totalCount?: string;
  /** 오류 코드 (0=성공, 그 외=오류) */
  errorCode?: string;
  /** 현재 페이지 번호 */
  currentPage?: string;
}

export interface Juso {
  /** 상세 건물 이름 목록 */
  detBdNmList?: string;
  /** 영문 주소 */
  engAddr?: string;
  /** 도로명 */
  rn?: string;
  /** 읍면동 이름 */
  emdNm?: string;
  /** 우편번호 */
  zipNo?: string;
  /** 도로명주소 2 */
  roadAddrPart2?: string;
  /** 읍면동 번호 */
  emdNo?: string;
  /** 시군구 이름 */
  sggNm?: string;
  /** 지번 주소 */
  jibunAddr?: string;
  /** 시도 이름 */
  siNm?: string;
  /** 도로명주소 1 */
  roadAddrPart1?: string;
  /** 건물 이름 */
  bdNm?: string;
  /** 행정동 코드 */
  admCd?: string;
  /** 지하여부 */
  udrtYn?: string;
  /** 번지 본번 */
  lnbrMnnm?: string;
  /** 도로명 주소 */
  roadAddr?: string;
  /** 번지 부번 */
  lnbrSlno?: string;
  /** 건물 본번 */
  buldMnnm?: string;
  /** 건물 종류 코드 */
  bdKdcd?: string;
  /** 법정동 이름 */
  liNm?: string;
  /** 도로명 코드 */
  rnMgtSn?: string;
  /** 산여부 */
  mtYn?: string;
  /** 건물 관리 번호 */
  bdMgtSn?: string;
  /** 건물 부번 */
  buldSlno?: string;
}

export interface UserFindStats {
  /** 유저의 ID */
  _id?: string;
  /** 유저의 타입. */
  type?: number;
  /** 실 이름 */
  realName?: string;
  /** 유저가 보는 이름 */
  name?: string;
  /** 사용자의 성별. */
  gender?: string;
  /** fcm token 값을 키로 한 디바이스 정보 */
  deviceInfos?: Record<string, any>;
  /** 병원내 계정의 직/직책 */
  jobType?: string;
  /** 생성일 */
  createdAt?: string;
}

export interface ApiResponseAbnormal01 {
  /** 응답 코드 (0=성공, 그 외=오류) */
  code?: number;
  /** 응답 데이터 (User_FindStats 객체 n개 + User_HServicePhotoAuthorizationType 객체 1개) */
  data: (UserFindStats | UserHServicePhotoAuthorizationType)[];
  /** 응답 메시지 */
  message?: string;
}

export interface UserHServicePhotoAuthorizationType {
  /** 사용자 아이디 - ObjectId */
  _id: string;
  /** 전화번호 문자열 */
  phone?: string;
  /** 유저의 타입. */
  type?: number;
  /** 로그인 시 사용되는 id */
  id?: string;
  /** 실 이름 */
  realName?: string;
  /** 유저가 보는 이름 */
  name?: string;
  /** 생년 월 일 */
  birth?: string;
  /** 사용자의 성별. */
  gender?: string;
  /** 사용자의 나이 */
  age?: string;
  visit?: string;
  /** 사용자의 상태 */
  status?: string;
  /** 프로필 이미지로 사용될 파일의 ID */
  photo?: File;
  /** 마지막으로 저장된 fcm token 값 */
  fcmToken?: string;
  /** 등록된 모든 fcm token 배열 */
  deviceTokens?: any[];
  /** fcm token 값을 키로 한 디바이스 정보 */
  deviceInfos?: Record<string, any>;
  /** 마지막으로 저장된 사용자의 OS 정보 */
  d_OS?: string;
  /** 마지막으로 저장된 OS 버전 정보 */
  d_OS_Version?: string;
  /** 마지막으로 저장된 App 버전 정보 */
  d_App_Version?: string;
  /** 마지막으로 저장된 디바이스의 이름 */
  d_Name?: string;
  /** 사용자가 진행중인 HService ID 배열 */
  hservices?: HServiceNurseDoctorHospitalChatroom[];
  /** 사용자가 속해 있는 병원 ID 배열 */
  hospitalID?: any[];
  /** 계정의 초기화 진행 여부 플래그 */
  needInitial?: boolean;
  /** 매니저 유저의 경우  소개글 */
  introduction?: string;
  /** 매니저 계정의 경우  경력. */
  career?: string;
  isAfterDoc?: boolean;
  /** 계정의 탈퇴 여부 플래그 */
  isLeave?: boolean;
  /** 마지막으로 로그인한 일시 */
  lastLogin?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막으로 수정된 일시 */
  updatedAt?: string;
  /** 환자의 경우  가입 일시. (가장 최근 가입한 HService 기준 갱신) */
  joinedAt?: string;
  /** 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값. */
  isDoctor?: boolean;
  /** 예약만 등록 유저 여부 */
  isUnregisteredUser?: boolean;
  /** 환자의 경우  가입하게된 Short URL 경로 */
  joinPath?: string;
  /** 환자의 경우  가입 시 방문한 경유페이지(layover) */
  layoverType?: string;
  /** 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_terms?: string;
  /** 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_privacy?: string;
  /** 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_sensitive?: string;
  /** 병원 계정의 경우  환자 등록 가능 여부 플래그 */
  auth_regist_user?: boolean;
  /** 권한 설정 ID */
  authorizationTypeID?: AuthorizationType;
  /** 병원내 계정의 직/직책 */
  jobType?: string;
  /** 대시보드 접근권한 */
  canReadDashboard?: boolean;
  /**
   * 기본 상담사 여부
   * @default false
   */
  isDefaultCounselor: boolean;
}

export interface HServiceNurseDoctorHospitalChatroom {
  /** 서비스 대상이 되는 유저 ID */
  userID?: string;
  /** 서비스 대상의 이름 */
  name?: string;
  /** 서비스 대상의 생년월일 */
  birth?: string;
  /** 서비스 대상의 전화번호 */
  phone?: string;
  /** 서비스 대상의 성별 */
  gender?: string;
  /** 서비스 대상의 차트번호 */
  chartNumber?: string;
  /** 서비스 진행 매니저의 ID */
  nurseID?: UserPhoto;
  /** 서비스 진행 매니저가 여럿인 경우의 매니저 ID 배열 */
  nurseIDs?: any[];
  /** 담당의 유저 ID */
  doctorID?: User;
  /** 서비스가 진행중인 병원의 ID */
  hospitalID?: HospitalRepresentImage;
  /** 서비스 내 포함된 채팅방 ID */
  chatRoomID?: ChatRoom;
  /** 전능 대표 연동 고객번호 (유일) */
  ALCustomerNumber?: string;
  /** 전능 연동 고객번호 리스트 */
  ALCustomerNumbers?: any[];
  /** 서비스 내 작성된 모든 메모의 ID 배열 */
  memos?: any[];
  /** 매니저만 작성/열람 가능한 메모 ID 배열 */
  managementDiaries?: any[];
  /** 고객 태그 ObjectID 배열 */
  userTagIDs?: any[];
  /** 환자 설정 완료 여부(설정/미설정 수 count용) */
  hasPatientSetting?: boolean;
  /** 초기 치료내역 문자열 배열 */
  initialTreatments?: any[];
  /** 초기 치료내역 중  기타를 선택하고 입력한 내역 */
  etcTreatments?: string;
  /** 읽지 않은 매니저 메모의 존재 여부 */
  hasUnreadNurseMemo?: boolean;
  /** 읽지않은 병원 메모 존재 유무 */
  hasUnreadDoctorMemo?: boolean;
  /** 문자유입 프로세스를 통해 서비스를 시작한 경우 유입 Link */
  shortLinkID?: string;
  /** 링크형태의 웹을 통해 진입한 유저의 경우 Type */
  linkType?: string;
  /** 서비스 환자에 대한 간단 설명 */
  description?: string;
  /** 병원 계정의 경우  new 뱃지 표기를 위한 플래그 */
  new?: boolean;
  /** 가입 상태에 대한 string 플래그 */
  status?: string;
  /** query를 위한 서비스 시작 여부 플래그 */
  isRun?: boolean;
  /** 서비스 종료 구분 플래그 */
  isClosed?: boolean;
  /** 서비스 종료시 사용자가 선택한 서비스 종료 이유. 혹은 병원에서 서비스를 종료한 후 사용자에게 보여주기 위한 문구. */
  closeReason?: any[];
  /** 서비스 약관 동의 일시 (HService 기준) */
  agree_terms?: string;
  /** 개인정보 보호방침 동의 일시 (HService 기준) */
  agree_privacy?: string;
  /** 민감정보 관리방침 동의 일시 (HService 기준) */
  agree_sensitive?: string;
  /** 가입일시 */
  joinedAt?: string;
  /** 서비스 대상 유저의 마지막 로그인 일시 */
  lastLogin?: string;
  /** 마지막 유저의 채팅 모델 ID */
  lastUserChat?: string;
  /** 마지막 유저의 채팅 전송 일시 */
  lastUserChatDate?: string;
  /** 마지막 유저 채팅 존재 유무 */
  hasLastUserChat?: boolean;
  /** 마지막 매니저의 채팅 모델 ID */
  lastNurseChat?: string;
  /** 마지막 매니저의 채팅 전송 일시 */
  lastNurseChatDate?: string;
  /** 마지막 매니저 채팅 존재 유무 */
  hasLastNurseChat?: boolean;
  /** 채팅방에서 마지막으로 수신한 메세지 */
  lastMessage?: string;
  /** 마지막으로 수신된 메세지의 수신 일시 */
  lastMessageUpdatedAt?: string;
  /** 마지막 가입 문자 메시지 수신일자 */
  lastSMSDate?: string;
  /** 고객 유형(치료 유형) 카테고리 ID 목록 */
  treatmentCategories?: any[];
  /** 치료시작일 */
  treatmentStartDate?: string;
  /** 초진/재진 여부 */
  isFirstVisit?: boolean;
  /** 테스트 계정 여부. */
  isTest?: boolean;
  /** 예약만 등록 유저 여부 */
  isUnregisteredUser?: boolean;
  /** // 미가입 - 발송 예정인 기본 운동콘텐츠 목록 */
  reservedVCHIDs?: any[];
  /** 전송된 운동콘텐츠의 중 카테고리 ObjectID 배열. 누적 */
  vccIDs?: any[];
  /** 가장 최근에 운동콘텐츠가 전송된 날짜 */
  lastVCUDate?: string;
  /** 모든 운동콘텐츠가 종료되는 날짜 */
  lastVCUEndDate?: string;
  /** 직접 전송한 운동콘텐츠 유무. */
  hasVCU?: boolean;
  /** 병원에서 설정한 평균 이행률 이상 달성했는지 여부 */
  isOverHCompletionRate?: boolean;
  /** 운동콘텐츠 진행중 여부. */
  isVCUOngoing?: boolean;
  /** 합산 공유횟수(현재 반올림 하여 정수로 표현중이나  변경될 수 있음.) */
  sumShareCount?: number;
  /** 평균 이행률(현재 반올림 하여 정수로 저장하나  double 로 변경될 수 있음) */
  avgCompletionRate?: number;
  /** 운동콘텐츠 전송 필요 종모양 알람 표시 여부 */
  needVCU?: boolean;
  /** 운동콘텐츠 발송화면(Electron) 에서의 정렬을 위한 코드 */
  sortDigitVC?: string;
  /** 구분정보1 서비스 매니저가 고객별 입력 가능한 구분정보 */
  classificationNote1?: string;
  /** 구분정보2 서비스 매니저가 고객별 입력 가능한 구분정보 */
  classificationNote2?: string;
  /** 서비스 시작을 기준으로 카운팅되는 정수 인덱스 */
  seq?: number;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
  /** 서비스 시작일 */
  startedAt?: string;
}

export interface UserPhoto {
  /** 전화번호 문자열 */
  phone?: string;
  /** 유저의 타입. */
  type?: number;
  /** 로그인 시 사용되는 id */
  id?: string;
  /** 실 이름 */
  realName?: string;
  /** 유저가 보는 이름 */
  name?: string;
  /** 생년 월 일 */
  birth?: string;
  /** 사용자의 성별. */
  gender?: string;
  /** 사용자의 나이 */
  age?: string;
  visit?: string;
  /** 사용자의 상태 */
  status?: string;
  /** 프로필 이미지로 사용될 파일의 ID */
  photo?: File;
  /** 마지막으로 저장된 fcm token 값 */
  fcmToken?: string;
  /** 등록된 모든 fcm token 배열 */
  deviceTokens?: any[];
  /** fcm token 값을 키로 한 디바이스 정보 */
  deviceInfos?: Record<string, any>;
  /** 마지막으로 저장된 사용자의 OS 정보 */
  d_OS?: string;
  /** 마지막으로 저장된 OS 버전 정보 */
  d_OS_Version?: string;
  /** 마지막으로 저장된 App 버전 정보 */
  d_App_Version?: string;
  /** 마지막으로 저장된 디바이스의 이름 */
  d_Name?: string;
  /** 사용자가 진행중인 HService ID 배열 */
  hservices?: any[];
  /** 사용자가 속해 있는 병원 ID 배열 */
  hospitalID?: any[];
  /** 계정의 초기화 진행 여부 플래그 */
  needInitial?: boolean;
  /** 매니저 유저의 경우  소개글 */
  introduction?: string;
  /** 매니저 계정의 경우  경력. */
  career?: string;
  isAfterDoc?: boolean;
  /** 계정의 탈퇴 여부 플래그 */
  isLeave?: boolean;
  /** 마지막으로 로그인한 일시 */
  lastLogin?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막으로 수정된 일시 */
  updatedAt?: string;
  /** 환자의 경우  가입 일시. (가장 최근 가입한 HService 기준 갱신) */
  joinedAt?: string;
  /** 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값. */
  isDoctor?: boolean;
  /** 예약만 등록 유저 여부 */
  isUnregisteredUser?: boolean;
  /** 환자의 경우  가입하게된 Short URL 경로 */
  joinPath?: string;
  /** 환자의 경우  가입 시 방문한 경유페이지(layover) */
  layoverType?: string;
  /** 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_terms?: string;
  /** 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_privacy?: string;
  /** 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_sensitive?: string;
  /** 병원 계정의 경우  환자 등록 가능 여부 플래그 */
  auth_regist_user?: boolean;
  /** 권한 설정 ID */
  authorizationTypeID?: AuthorizationType;
  /** 병원내 계정의 직/직책 */
  jobType?: string;
  /** 대시보드 접근권한 */
  canReadDashboard?: boolean;
}

export interface AuthorizationType {
  /** 권한타입 객체 오브젝트 아이디 */
  _id: string;
  /**
   * 샘플 데이터 구분
   * @default false
   */
  isSample?: boolean;
  /** 권한타입이 속한 병원 아이디 */
  hospitalID: string;
  /** 권한타입의 이름. 마스터, 관리자, 일반 중 하나 */
  name?: string;
  /** 환자 채팅 관리 권한 */
  canControlPatientChatting?: boolean;
  /** 환자 서비스 차단 권한 */
  canBanPatientToService?: boolean;
  /** 자동화 설정 권한 */
  canUpsertAutomation?: boolean;
  /** 자동화 삭제 권한 */
  canDeleteAutomation?: boolean;
  /** 자동화 대시보드 조회 권한 */
  canReadAutomationDashboard?: boolean;
  /** 콘텐츠 수정 권한 */
  canUpsertContent?: boolean;
  /** 콘텐츠 삭제 권한 */
  canDeleteContent?: boolean;
  /** 메뉴얼 폴더 및 태그 설정 권한 */
  canControlManualFolderAndTagStatus?: boolean;
  /** 메뉴얼 생성 권한 */
  canCreateManual?: boolean;
  /** 병원 정보 조회 권한 */
  canAccessHospitalInformation?: boolean;
  /** 서비스 정보 조회 권한 */
  canAccessHospitalService?: boolean;
  /** 계정 정보 조회 권한 */
  canAccessHospitalAccount?: boolean;
  /** 결제 관리 접근 권한 */
  canAccessPaymentManagement?: boolean;
  /** 결제 권한 */
  canCreatePayment?: boolean;
  /** 서비스 정보 수정 권한 */
  canModifyService?: boolean;
  /** 서비스 종료 권한 */
  canSuspendService?: boolean;
  /** 예약설정 수정 권한 */
  canManageReservation?: boolean;
  /** 예약설정 스케줄 수정 권한 */
  canManageSchedule?: boolean;
  /** 병원정보 수정 권한 */
  canUpdateHospital?: boolean;
  /** 환자 정보 다운로드 권한 */
  canDownloadPatientData?: boolean;
  /** 재진 마케팅 등록/수정 */
  canUpsertMarketingAutomation?: boolean;
  /** 재진 마케팅 삭제 */
  canDeleteMarketingAutomation?: boolean;
  /** 대시보드 조회 여부 */
  canReadMarketingAutomationDashboard?: boolean;
  /** 결제 정보 조회 여부 */
  canReadPaymentRecords?: boolean;
  /** 재진마케팅 전송 기록 엑셀 다운로드 권한 */
  canDownloadMarketingHistory?: boolean;
  /** 상담자동화 발송 기록 엑셀 다운로드 권한 */
  canDownloadConsultationHistory?: boolean;
  /** 메디팔 AI 사용현황 조회 권한 */
  canReadMedipalAIUsage?: boolean;
  /** 메디팔 AI 업무 조정 권한 */
  canAdjustMedipalAITask?: boolean;
  /** 메디팔 AI 예약 조회 권한 */
  canReadMedipalAIReservation?: boolean;
  /** 메디팔 AI 콜 조회 권한 */
  canReadMedipalAICall?: boolean;
  /** 메디팔 AI 콜 최고 권한 */
  canControlMedipalAICall?: boolean;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface User {
  /** 전화번호 문자열 */
  phone?: string;
  /** 유저의 타입. */
  type?: number;
  /** 로그인 시 사용되는 id */
  id?: string;
  /** 실 이름 */
  realName?: string;
  /** 유저가 보는 이름 */
  name?: string;
  /** 생년 월 일 */
  birth?: string;
  /** 사용자의 성별. */
  gender?: string;
  /** 사용자의 나이 */
  age?: string;
  visit?: string;
  /** 사용자의 상태 */
  status?: string;
  /** 프로필 이미지로 사용될 파일의 ID */
  photo?: string;
  /** 마지막으로 저장된 fcm token 값 */
  fcmToken?: string;
  /** 등록된 모든 fcm token 배열 */
  deviceTokens?: any[];
  /** fcm token 값을 키로 한 디바이스 정보 */
  deviceInfos?: Record<string, any>;
  /** 마지막으로 저장된 사용자의 OS 정보 */
  d_OS?: string;
  /** 마지막으로 저장된 OS 버전 정보 */
  d_OS_Version?: string;
  /** 마지막으로 저장된 App 버전 정보 */
  d_App_Version?: string;
  /** 마지막으로 저장된 디바이스의 이름 */
  d_Name?: string;
  /** 사용자가 진행중인 HService ID 배열 */
  hservices?: any[];
  /** 사용자가 속해 있는 병원 ID 배열 */
  hospitalID?: any[];
  /** 계정의 초기화 진행 여부 플래그 */
  needInitial?: boolean;
  /** 매니저 유저의 경우  소개글 */
  introduction?: string;
  /** 매니저 계정의 경우  경력. */
  career?: string;
  isAfterDoc?: boolean;
  /** 계정의 탈퇴 여부 플래그 */
  isLeave?: boolean;
  /** 마지막으로 로그인한 일시 */
  lastLogin?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막으로 수정된 일시 */
  updatedAt?: string;
  /** 환자의 경우  가입 일시. (가장 최근 가입한 HService 기준 갱신) */
  joinedAt?: string;
  /** 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값. */
  isDoctor?: boolean;
  /** 예약만 등록 유저 여부 */
  isUnregisteredUser?: boolean;
  /** 환자의 경우  가입하게된 Short URL 경로 */
  joinPath?: string;
  /** 환자의 경우  가입 시 방문한 경유페이지(layover) */
  layoverType?: string;
  /** 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_terms?: string;
  /** 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_privacy?: string;
  /** 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_sensitive?: string;
  /** 병원 계정의 경우  환자 등록 가능 여부 플래그 */
  auth_regist_user?: boolean;
  /** 권한 설정 ID */
  authorizationTypeID?: AuthorizationType;
  /** 병원내 계정의 직/직책 */
  jobType?: string;
  /** 대시보드 접근권한 */
  canReadDashboard?: boolean;
}

export interface ChatRoom {
  /** 채팅방에 참여중인 서비스 ID */
  hserviceID?: string;
  /** 채팅방에 참여중인(Push notification을 받아야 하는.) 유저의 ID 배열 */
  users?: any[];
  /** 채팅의 주 대상이 되는(환자 or 의사) 유저의 ID */
  userID?: string;
  /** 채팅방 ID(_ID와 동일하고 _ID 사용 권장) */
  id?: string;
  /** 채팅방 _ID */
  _id: string;
  /** 채팅방 제목 */
  title?: string;
  /** 서비스매니저가 읽지 않은 채팅의 수 */
  n_UnreadCount?: number;
  /** 대상 유저가 읽지 않은 채팅의 수 */
  c_UnreadCount?: number;
  /** 채팅의 대상이 되는 유저가 처음 진입했는가에 대한 질의를 위한 플래그 */
  c_isFirstEnter?: boolean;
  /** 서비스 매니저의 첫 메세지 전송 여부 플래그 */
  c_isFirstNurseChat?: boolean;
  /** 대상 유저의 첫 메세지 구분 플래그 */
  c_isFirstUserChat?: boolean;
  /** 매니저의 첫 메세지 전송 이후를 확인하기 위한 플래그 */
  c_isSendedFirstNurseChat?: boolean;
  /** 해당 채팅방의 귀속 병원 ID */
  hospitalID?: string;
  /** 병원 계정과의 채팅방임을 구분짓는 플래그 */
  isDoctor?: boolean;
  /** 첫 메세지 전송을 통한 SMS 전송 여부 구분 플래그 */
  hasFirstSMS?: boolean;
  /** 마지막으로 전달된 메세지 모델 ID */
  lastMessage?: string;
  /** 마지막 메세지 전달 일시 */
  lastMessageUpdatedAt?: string;
  /** 채팅방 내에서의 총 메세지 수 */
  totalChatCount?: number;
  /** 마지막으로 환자가 전달한 채팅의 ObjectId */
  lastUserChat?: string;
  /** 마지막으로 환자가 전달한 채팅의 일시 */
  lastUserChatDate?: string;
  /** 마지막으로 환자가 아닌 유저가 전달한 채팅의 ObjectId */
  lastNurseChat?: string;
  /** 마지막으로 환자가 아닌 유저가 전달한 채팅의 일시 */
  lastNurseChatDate?: string;
  /** 참여 유저별 뱃지 카운트 정보 */
  badgeCountInfo?: Record<string, any>;
  /** 사용자 ID 별 필요한 정보의 집합 */
  info: {
    /**
     * 사용자 ID
     * @example "60b12345b1234c56789abcd1"
     */
    userID: string;
    /**
     * 채팅을 읽지 않은 갯수
     * @example 0
     */
    count: number;
    /**
     * 개인별 출력되는 채팅방 제목
     * @example "단체방"
     */
    title: string;
  }[];
  /** 1대1 채팅방 구분자 */
  isMultiUser?: boolean;
  /** 채팅방의 병원 응대 필요 (상담 요청) 여부 */
  isChatResponseRequired?: boolean;
  /** 병원 응대 필요 채팅 (상담 요청) 존재 여부 */
  hasUnreadChatResponseRequired?: boolean;
  /** 채팅방 삭제 여부 */
  isRemoved?: boolean;
  /** 채팅방 타입 정의 */
  roomType?: string;
  /** 카카오 상담톡을 위한 추가 정보 */
  ikakaoInfo?: Record<string, any>;
  /** 채팅방의 담당자 ID 배열 */
  counselors?: any[];
  /**
   * 상담 진행중 여부
   * @default false
   */
  isCounselInProgress?: boolean;
  /**
   * 번역 사용 여부
   * @default false
   */
  usingTranslation?: boolean;
  /** 언어 ObjectId */
  languageID?: string;
  /** 활성화 여부 */
  isActive?: boolean;
  /** 채팅방에 연결된 부모 서비스 ID. 연동된 내용이 없으면 hserviceID와 동일 */
  parentHServiceID: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface HospitalMFindOneHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    name: string;
    shortName: string;
    businessName?: string;
    /** MSO(2501) 계정 로그인 시 좌측 병원 선택 목록에 표시되는 다중 병원명 (선택, 최대 15자) */
    msoHospitalName?: string;
    address?: string;
    addressInfo?: Record<string, string>;
    addressInfoNaver?: Record<string, string>;
    department?: string[];
    introduction?: string;
    representImage?: {
      /** MongoDB Identifier */
      _id: string;
      paths: string[];
      aws?: {
        ETag: string;
        Location: string;
        Key: string;
        key: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize: number;
        fileName: string;
      }[];
    };
    representUser: string;
    homepageURL?: string;
    phone?: string;
    smsPhone?: string;
    isSMSSendingBlocked?: boolean;
    /** @format date */
    smsSendingBlockedAt?: string;
    /** @format date */
    smsSendingUnblockedAt?: string;
    smsSendingBlockedBy?: string;
    smsSendingBlockReason?: string;
    isHiddenPhoneNumber?: boolean;
    usingHomepage?: boolean;
    initialChat?: string;
    initialChats?: {
      chatType?: number;
      content?: string;
      fileIDs?: any[] | null;
    }[];
    defaultFlag: string;
    therapyList?: string[];
    additionalInfo?: {
      stringInfo?: string;
    };
    isBasicMessage?: boolean;
    smsMessage?: string;
    smsMessageA?: string;
    smsMessageB?: string;
    smsChatMessage?: string;
    smsChatMessageA?: string;
    smsChatMessageB?: string;
    usingBasicMessage?: boolean;
    smsBasicMessage?: string;
    smsBasicMessageEdit?: string;
    usingReservationMessage?: boolean;
    smsReservation?: string;
    smsReservationEdit?: string;
    usingResendMessage?: boolean;
    smsResendMessage?: string;
    smsResendMessageEdit?: string;
    usingAutoReservedSMS?: boolean;
    autoReservedSMSMessage?: string;
    autoReservedSMSDelayDay?: number;
    autoReservedSMSHour?: number;
    chatReservationGuide?: string;
    careSchedule?: {
      dayIndex?: number;
      /** @format date */
      startedAt?: string;
      /** @format date */
      endedAt?: string;
    }[];
    careScheduleDescription?: string;
    smsLogoImage?:
      | string
      | {
          _id?: string;
          paths?: string[] | null;
          aws?: any[] | null;
        };
    isUsingLogo?: boolean;
    nurseID: string;
    nurseIDs?: string[];
    hospitalType?: "single" | "multi";
    usingRegistUser?: boolean;
    isClosed: boolean;
    serviceSetting: string;
    hasActiveSheet?: boolean;
    isSecondEdition?: boolean;
    usingVideoContent: boolean;
    usingHospitalEvent?: boolean;
    healthContentCategory?: string[];
    usingHealthContent: boolean;
    usingHospitalContent?: boolean;
    integrationSetting?: string;
    usingAfterhoursPopup?: boolean;
    afterhoursPopupContent?: string;
    usingV2ReservationSheet?: boolean;
    usingSaaSReservation?: boolean;
    isEnabledSaaS?: boolean;
    isTest?: boolean;
    /** 병원 별 언어와 국가 설정. 예: ko-KR (한국어, 대한민국), en-US (영어, 미국), vn-VN (베트남어, 베트남) */
    locale?: string;
    /** 병원 별 시간대 설정. 예: Asia/Seoul (서울), Asia/Ho_Chi_Minh (호치민) */
    timezone?: string;
    unsubscriptionPhone?: string;
    unsubscriptionNumber?: string;
    /** @format date */
    createdAt: string;
    /** @format date */
    updatedAt: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface HospitalMFindDoctorsHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 전화번호 문자열 */
    phone?: string;
    /**
     * 유저의 타입.
     * 1000 = 환자
     * 2xxx = 병원 유저
     *  3xxx = 메디팔 유저
     */
    type: number;
    /** 로그인 시 사용되는 id */
    id: string;
    /** 실 이름 */
    realName: string;
    /** 유저가 보는 이름 */
    name: string;
    /**
     * 생년 월 일
     * 과거 데이터는 YYMMDD의 여섯자리
     * 2차 프로덕트 이후에는 YYYYMMDD 여덟자리
     */
    birth: string;
    /**
     * 사용자의 성별
     * F = 여성
     * M = 남성
     */
    gender: string;
    /** 사용자의 나이 */
    age: string;
    visit: string;
    /**
     * 사용자의 상태
     * '-' = status값 적용 전의 모든 유저의 기본
     * 'pending' = 사용자 정보는 생성되어 있으나 가입되지 않은 상태 (문자메시지로 가입 문자 발송)
     * 'installed' = 가입 문자 내 다운로드 URL로 접속하고, '다운로드' 버튼을 눌렀을 시 변경
     * 'run' = 가입 문자를 통해 앱을 설치받고 가입까지 완료한 경우
     * 'qr' = QR코드로 가입한 경우
     */
    status: string;
    /** 프로필 이미지로 사용될 파일의 ID */
    photo?: {
      /** MongoDB Identifier */
      _id: string;
      paths?: string[] | null;
      aws?: {
        ETag?: string;
        Location?: string;
        Key?: string;
        key?: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize?: string;
        fileName?: string;
      }[];
    };
    /** 마지막으로 저장된 fcm token 값 */
    fcmToken: string;
    /**
     * 사용자의 언어 설정 (ko - 한국어, en - 영어만 지원)
     * @example "ko"
     */
    language: string;
    /** 등록된 모든 fcm token 배열 */
    deviceToken: string;
    /**
     * fcm token 값을 키로 한 디바이스 정보
     * "deviceInfos": {
     * "%FCMTOKEN%" : {
     * "OS" : "Android",
     * "version" : 33,
     * "deviceName" : "SM-S901N",
     * "appVersion" : "1.7.3"
     * }
     * }
     */
    deviceInfos?: Record<string, any>;
    /** 마지막으로 저장된 사용자의 OS 정보 */
    d_OS: string;
    /** 마지막으로 저장된 OS 버전 정보 */
    d_OS_Version: string;
    /** 마지막으로 저장된 App 버전 정보 */
    d_App_Version: string;
    /** 마지막으로 저장된 디바이스의 이름 */
    d_Name: string;
    /** 사용자가 진행중인 HService ID 배열 */
    hservices?: string[];
    /** 사용자가 속해 있는 병원 ID 배열 */
    hospitalID?: string[];
    /**
     * 계정의 초기화 진행 여부 플래그
     * 병원계정의 경우 비밀번호 재설정으로 이동
     */
    needInitial: boolean;
    /** 매니저 유저의 경우, 소개글 */
    introduction: string;
    /** 매니저 계정의 경우, 경력. */
    career: string;
    isAfterDoc: boolean;
    /** 계정의 탈퇴 여부 플래그 */
    isLeave: boolean;
    /**
     * 마지막으로 로그인한 일시
     * @format date
     */
    lastLogin?: string;
    /**
     * 생성 일시
     * @format date
     */
    createdAt: string;
    /**
     * 마지막 수정 일시
     * @format date
     */
    updatedAt: string;
    /**
     * 환자의 경우, 가입 일시. (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    joinedAt?: string;
    /**
     * 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값.
     * 이외 type의 경우 해당값 무시
     *
     * type=2000, isDoctor=true일 경우 [원장] - 담당의로 지정 가능
     * type=2000, isDoctor=false일 경우 [직원] - 담당의로 지정 불가
     */
    isDoctor: boolean;
    /** 예약만 등록 유저 여부 */
    isUnregisteredUser: string;
    /** 환자의 경우, 가입하게된 Short URL 경로 */
    joinPath: string;
    /** 환자의 경우, 가입 시 방문한 경유페이지(layover) */
    layoverType: string;
    /**
     * 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_terms: string;
    /**
     * 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_privacy: string;
    /**
     * 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_sensitive: string;
    /** 병원 계정의 경우, 환자 등록 가능 여부 플래그 */
    auth_regist_user: boolean;
    /** 권한 설정 ID */
    authorizationTypeID: string;
    /** 병원내 계정의 직/직책 */
    jobType: string;
    /** 대시보드 접근권한 */
    canReadDashboard: boolean;
    /** 소속 국가 아이디 */
    countryCode?: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AuthorizationTypeForV3 {
  /** 접근 권한의 ID */
  _id: string;
  /** 접근 권한 역할 이름 */
  name: string;
  /** 접근 권한 역할 설명 */
  description: string;
  /** 병원 내에서 직접 정의한 역할인지 여부 */
  isCustomizedRole: boolean;
  patientConsultation: AuthorizationSection;
  patientManagement: AuthorizationSection;
  automation: AuthorizationSection;
  content: AuthorizationSection;
  manualManagement: AuthorizationSection;
  hospitalSettings: AuthorizationSection;
  revisitMarketing: AuthorizationSection;
  medipalAI: AuthorizationSection;
}

export interface AuthorizationSection {
  /**
   * 개별 권한 세부 설정 영역 이름
   * @example "고객상담"
   */
  name: string;
  types: AuthorizationTypeDetail[];
}

export interface AuthorizationTypeDetail {
  /** 세부 권한의 이름 */
  name: string;
  /** 세부 권한의 값 */
  value: boolean;
  /** 세부 권한의 툴팁 */
  toolTip: string;
  /** 세부 권한 업데이트를 위한 필드 이름 */
  fieldNameForUpdate: string;
}

export interface HospitalNameControllerGetHospitalNamesBodyRequest {
  /** 병원 ID 목록 */
  hospitalIDs: string[];
}

export interface HospitalNameControllerGetHospitalNamesResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: Record<string, string>;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface HospitalAccountControllerCreateAccountBodyRequest {
  hospitalID: string;
  id: string;
  password: string;
  authorizationType: "마스터" | "관리자" | "직원" | "직원 2" | "직원 3";
  jobType: string;
}

export interface HospitalAccountControllerCreateAccountResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    isCreatedSucess: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface HospitalsBackgroundJobsHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  /** 병원 별 백그라운드 작업 목록 */
  data: {
    /** 배치 작업 ID */
    bulkJobId: string;
    /** 해당 날짜에 임시 저장한 환자 정보 갯수 */
    allPatientsAtThatDay?: number;
    /** 전체 작업 수 */
    totalJobs?: number;
    /** 완료된 작업 수 */
    completedJobs?: number;
    /** 실패한 작업 수 */
    failedJobs?: number;
    /** 상태 */
    status?: string;
    /**
     * 작업 시작 시간
     * @format date
     */
    startTime?: string;
    /**
     * 작업 종료 시간
     * @format date
     */
    endTime?: string;
    /** 과거 고객 업로드 일괄 입력 여부 */
    isBulkImport?: boolean | null;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface SingleHospitalPushSettingHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 일렉트론 사용자의 병원 푸시 설정 ID
     * @example "639c31e489cce6e33c25ab6a"
     */
    _id: string;
    /**
     * 담당자로 지정된 채팅방의 신규 메시지를 수신할지 여부
     * @example false
     */
    onInChargeChat: boolean;
    /**
     * 담당자로 지정된 채팅방에 대해서 특정 시간에만 신규 메시지를 수신할지 여부
     * @example false
     */
    hasTimeSettingForInChargeChat: boolean;
    /**
     * 담당자로 지정된 채팅방의 신규 메시지를 수신한다는 가정 하에 알림을 받을 시작 시간
     * @format date
     * @example "2022-01-01T00:00:00.000Z"
     */
    inChargeChatStartedAt?: string;
    /**
     * 담당자로 지정된 채팅방의 신규 메시지를 수신한다는 가정 하에 알림을 받을 종료 시간
     * @format date
     * @example "2022-01-01T00:00:00.000Z"
     */
    inChargeChatEndedAt?: string;
    /**
     * 환자와의 채팅에서 참여자로 참여한 경우 푸시 알림을 수신할지 여부
     * @example true
     */
    onChatsAll: boolean;
    /**
     * 환자와의 채팅에서 참여자로 참여한 경우 정해진 시간대에만 모든 채팅 메세지 푸시 알림을 수신할지 여부
     * @example false
     */
    onChatsDependsTime: boolean;
    /**
     * 환자와의 채팅에서 참여자로 참여한 경우 정해진 시간대에만 모든 채팅 메세지 푸시 알림을 수신한다는 가정 하에 알림을 받을 시작 시간
     * @format date
     * @example "2022-01-01T00:00:00.000Z"
     */
    chatStartedAt?: string;
    /**
     * 환자와의 채팅에서 참여자로 참여한 경우 정해진 시간대에만 모든 채팅 메세지 푸시 알림을 수신한다는 가정 하에 알림을 받을 종료 시간
     * @format date
     * @example "2022-01-01T00:00:00.000Z"
     */
    chatEndedAt?: string;
    /**
     * 병원에서 원장을 포함한 직원 간의 채팅이 발생한 경우 모든 푸시 알림을 수신할지 여부
     * @example true
     */
    onManagerChatsAll: boolean;
    /**
     * 병원에서 원장을 포함한 직원 간의 채팅이 발생한 경우 정해진 시간대에만 모든 푸시 알림을 수신할지 여부
     * @example false
     */
    onManagerChatsDependsTime: boolean;
    /**
     * 병원에서 원장을 포함한 직원 간의 채팅이 발생한 경우 정해진 시간대에만 모든 푸시 알림을 수신한다는 가정 하에 알림을 받을 시작 시간
     * @format date
     * @example "2022-01-01T00:00:00.000Z"
     */
    managerChatStartedAt?: string;
    /**
     * 병원에서 원장을 포함한 직원 간의 채팅이 발생한 경우 정해진 시간대에만 모든 푸시 알림을 수신한다는 가정 하에 알림을 받을 종료 시간
     * @format date
     * @example "2022-01-01T00:00:00.000Z"
     */
    managerChatEndedAt?: string;
    /**
     * 예약이 생성되었을 때 푸시 알림을 수신할지 여부
     * @example true
     */
    onReservationNew: boolean;
    /**
     * 예약이 변경되었을 때 푸시 알림을 수신할지 여부
     * @example true
     */
    onReservationChange: boolean;
    /**
     * 예약이 취소되었을 때 푸시 알림을 수신할지 여부
     * @example true
     */
    onReservationCancel: boolean;
    /**
     * 상담 모바일앱 - 담당자로 지정된 채팅방의 신규 메시지를 수신할지 여부
     * @example true
     */
    counselorChatsAllHm: boolean;
    /**
     * 상담 모바일앱 - 담당자로 지정된 채팅방에 대해서 특정 시간에만 신규 메시지를 수신할지 여부
     * @example false
     */
    counselorChatsWithTimeRangeHm: boolean;
    /**
     * 상담 모바일앱 - 담당자로 지정된 채팅방의 신규 메시지를 수신한다는 가정 하에 알림을 받을 시작 시간
     * @format date
     * @example "2022-01-02T00:00:00.000Z"
     */
    counselorChatsStartedAtHm?: string;
    /**
     * 상담 모바일앱 - 담당자로 지정된 채팅방의 신규 메시지를 수신한다는 가정 하에 알림을 받을 종료 시간
     * @format date
     * @example "2022-01-02T10:00:00.000Z"
     */
    counselorChatsEndedAtHm?: string;
    /**
     * 상담 모바일앱 - 환자와의 채팅에서 참여자로 참여한 경우 푸시 알림을 수신할지 여부
     * @example true
     */
    participantChatsAllHm: boolean;
    /**
     * 상담 모바일앱 - 환자와의 채팅에서 참여자로 참여한 경우 정해진 시간대에만 모든 채팅 메세지 푸시 알림을 수신할지 여부
     * @example false
     */
    participantChatsWithTimeRangeHm: boolean;
    /**
     * 상담 모바일앱 - 환자와의 채팅에서 참여자로 참여한 경우 정해진 시간대에만 모든 채팅 메세지 푸시 알림을 수신한다는 가정 하에 알림을 받을 시작 시간
     * @format date
     * @example "2022-01-02T00:00:00.000Z"
     */
    participantChatsStartedAtHm?: string;
    /**
     * 상담 모바일앱 - 환자와의 채팅에서 참여자로 참여한 경우 정해진 시간대에만 모든 채팅 메세지 푸시 알림을 수신한다는 가정 하에 알림을 받을 종료 시간
     * @format date
     * @example "2022-01-02T10:00:00.000Z"
     */
    participantChatsEndedAtHm?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface HospitalPushSettingUpdateHandlerBodyRequest {
  /**
   * 일렉트론 사용자의 병원 푸시 설정 ID
   * @example "639c31e489cce6e33c25ab6a"
   */
  _id: string;
  /**
   * 담당자로 지정된 채팅방의 신규 메시지를 수신할지 여부
   * @example false
   */
  onInChargeChat?: boolean;
  /**
   * 담당자로 지정된 채팅방에 대해서 특정 시간에만 신규 메시지를 수신할지 여부
   * @example false
   */
  hasTimeSettingForInChargeChat?: boolean;
  /**
   * 담당자로 지정된 채팅방의 신규 메시지를 수신한다는 가정 하에 알림을 받을 시작 시간
   * @format date
   * @example "2022-01-01T00:00:00.000Z"
   */
  inChargeChatStartedAt?: string;
  /**
   * 담당자로 지정된 채팅방의 신규 메시지를 수신한다는 가정 하에 알림을 받을 종료 시간
   * @format date
   * @example "2022-01-01T00:00:00.000Z"
   */
  inChargeChatEndedAt?: string;
  /**
   * 환자와의 채팅에서 참여자로 참여한 경우 푸시 알림을 수신할지 여부
   * @example true
   */
  onChatsAll?: boolean;
  /**
   * 환자와의 채팅에서 참여자로 참여한 경우 정해진 시간대에만 모든 채팅 메세지 푸시 알림을 수신할지 여부
   * @example false
   */
  onChatsDependsTime?: boolean;
  /**
   * 환자와의 채팅에서 참여자로 참여한 경우 정해진 시간대에만 모든 채팅 메세지 푸시 알림을 수신한다는 가정 하에 알림을 받을 시작 시간
   * @format date
   * @example "2022-01-01T00:00:00.000Z"
   */
  chatStartedAt?: string;
  /**
   * 환자와의 채팅에서 참여자로 참여한 경우 정해진 시간대에만 모든 채팅 메세지 푸시 알림을 수신한다는 가정 하에 알림을 받을 종료 시간
   * @format date
   * @example "2022-01-01T00:00:00.000Z"
   */
  chatEndedAt?: string;
  /**
   * 병원에서 원장을 포함한 직원 간의 채팅이 발생한 경우 모든 푸시 알림을 수신할지 여부
   * @example true
   */
  onManagerChatsAll?: boolean;
  /**
   * 병원에서 원장을 포함한 직원 간의 채팅이 발생한 경우 정해진 시간대에만 모든 푸시 알림을 수신할지 여부
   * @example false
   */
  onManagerChatsDependsTime?: boolean;
  /**
   * 병원에서 원장을 포함한 직원 간의 채팅이 발생한 경우 정해진 시간대에만 모든 푸시 알림을 수신한다는 가정 하에 알림을 받을 시작 시간
   * @format date
   * @example "2022-01-01T00:00:00.000Z"
   */
  managerChatStartedAt?: string;
  /**
   * 병원에서 원장을 포함한 직원 간의 채팅이 발생한 경우 정해진 시간대에만 모든 푸시 알림을 수신한다는 가정 하에 알림을 받을 종료 시간
   * @format date
   * @example "2022-01-01T00:00:00.000Z"
   */
  managerChatEndedAt?: string;
  /**
   * 예약이 생성되었을 때 푸시 알림을 수신할지 여부
   * @example true
   */
  onReservationNew?: boolean;
  /**
   * 예약이 변경되었을 때 푸시 알림을 수신할지 여부
   * @example true
   */
  onReservationChange?: boolean;
  /**
   * 예약이 취소되었을 때 푸시 알림을 수신할지 여부
   * @example true
   */
  onReservationCancel?: boolean;
  /**
   * 상담 모바일앱 - 담당자로 지정된 채팅방의 신규 메시지를 수신할지 여부
   * @example true
   */
  counselorChatsAllHm?: boolean;
  /**
   * 상담 모바일앱 - 담당자로 지정된 채팅방에 대해서 특정 시간에만 신규 메시지를 수신할지 여부
   * @example false
   */
  counselorChatsWithTimeRangeHm?: boolean;
  /**
   * 상담 모바일앱 - 담당자로 지정된 채팅방의 신규 메시지를 수신한다는 가정 하에 알림을 받을 시작 시간
   * @format date
   * @example "2022-01-02T00:00:00.000Z"
   */
  counselorChatsStartedAtHm?: string;
  /**
   * 상담 모바일앱 - 담당자로 지정된 채팅방의 신규 메시지를 수신한다는 가정 하에 알림을 받을 종료 시간
   * @format date
   * @example "2022-01-02T10:00:00.000Z"
   */
  counselorChatsEndedAtHm?: string;
  /**
   * 상담 모바일앱 - 환자와의 채팅에서 참여자로 참여한 경우 푸시 알림을 수신할지 여부
   * @example true
   */
  participantChatsAllHm?: boolean;
  /**
   * 상담 모바일앱 - 환자와의 채팅에서 참여자로 참여한 경우 정해진 시간대에만 모든 채팅 메세지 푸시 알림을 수신할지 여부
   * @example false
   */
  participantChatsWithTimeRangeHm?: boolean;
  /**
   * 상담 모바일앱 - 환자와의 채팅에서 참여자로 참여한 경우 정해진 시간대에만 모든 채팅 메세지 푸시 알림을 수신한다는 가정 하에 알림을 받을 시작 시간
   * @format date
   * @example "2022-01-02T00:00:00.000Z"
   */
  participantChatsStartedAtHm?: string;
  /**
   * 상담 모바일앱 - 환자와의 채팅에서 참여자로 참여한 경우 정해진 시간대에만 모든 채팅 메세지 푸시 알림을 수신한다는 가정 하에 알림을 받을 종료 시간
   * @format date
   * @example "2022-01-02T10:00:00.000Z"
   */
  participantChatsEndedAtHm?: string;
}

export interface HospitalPushSettingUpdateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 특정 일렉트론 사용자의 병원 푸시 설정이 성공적으로 수정되었는지 여부
     * @example true
     */
    isUpdatedSuccess: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface HospitalMobileSingleHospitalPushSettingHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 일렉트론 사용자의 병원 푸시 설정 ID
     * @example "639c31e489cce6e33c25ab6a"
     */
    _id: string;
    /**
     * 담당자로 지정된 채팅방의 신규 메시지를 수신할지 여부
     * @example false
     */
    onInChargeChat: boolean;
    /**
     * 담당자로 지정된 채팅방에 대해서 특정 시간에만 신규 메시지를 수신할지 여부
     * @example false
     */
    hasTimeSettingForInChargeChat: boolean;
    /**
     * 담당자로 지정된 채팅방의 신규 메시지를 수신한다는 가정 하에 알림을 받을 시작 시간
     * @format date
     * @example "2022-01-01T00:00:00.000Z"
     */
    inChargeChatStartedAt?: string;
    /**
     * 담당자로 지정된 채팅방의 신규 메시지를 수신한다는 가정 하에 알림을 받을 종료 시간
     * @format date
     * @example "2022-01-01T00:00:00.000Z"
     */
    inChargeChatEndedAt?: string;
    /**
     * 환자와의 채팅에서 참여자로 참여한 경우 푸시 알림을 수신할지 여부
     * @example true
     */
    onChatsAll: boolean;
    /**
     * 환자와의 채팅에서 참여자로 참여한 경우 정해진 시간대에만 모든 채팅 메세지 푸시 알림을 수신할지 여부
     * @example false
     */
    onChatsDependsTime: boolean;
    /**
     * 환자와의 채팅에서 참여자로 참여한 경우 정해진 시간대에만 모든 채팅 메세지 푸시 알림을 수신한다는 가정 하에 알림을 받을 시작 시간
     * @format date
     * @example "2022-01-01T00:00:00.000Z"
     */
    chatStartedAt?: string;
    /**
     * 환자와의 채팅에서 참여자로 참여한 경우 정해진 시간대에만 모든 채팅 메세지 푸시 알림을 수신한다는 가정 하에 알림을 받을 종료 시간
     * @format date
     * @example "2022-01-01T00:00:00.000Z"
     */
    chatEndedAt?: string;
    /**
     * 병원에서 원장을 포함한 직원 간의 채팅이 발생한 경우 모든 푸시 알림을 수신할지 여부
     * @example true
     */
    onManagerChatsAll: boolean;
    /**
     * 병원에서 원장을 포함한 직원 간의 채팅이 발생한 경우 정해진 시간대에만 모든 푸시 알림을 수신할지 여부
     * @example false
     */
    onManagerChatsDependsTime: boolean;
    /**
     * 병원에서 원장을 포함한 직원 간의 채팅이 발생한 경우 정해진 시간대에만 모든 푸시 알림을 수신한다는 가정 하에 알림을 받을 시작 시간
     * @format date
     * @example "2022-01-01T00:00:00.000Z"
     */
    managerChatStartedAt?: string;
    /**
     * 병원에서 원장을 포함한 직원 간의 채팅이 발생한 경우 정해진 시간대에만 모든 푸시 알림을 수신한다는 가정 하에 알림을 받을 종료 시간
     * @format date
     * @example "2022-01-01T00:00:00.000Z"
     */
    managerChatEndedAt?: string;
    /**
     * 예약이 생성되었을 때 푸시 알림을 수신할지 여부
     * @example true
     */
    onReservationNew: boolean;
    /**
     * 예약이 변경되었을 때 푸시 알림을 수신할지 여부
     * @example true
     */
    onReservationChange: boolean;
    /**
     * 예약이 취소되었을 때 푸시 알림을 수신할지 여부
     * @example true
     */
    onReservationCancel: boolean;
    /**
     * 상담 모바일앱 - 담당자로 지정된 채팅방의 신규 메시지를 수신할지 여부
     * @example true
     */
    counselorChatsAllHm: boolean;
    /**
     * 상담 모바일앱 - 담당자로 지정된 채팅방에 대해서 특정 시간에만 신규 메시지를 수신할지 여부
     * @example false
     */
    counselorChatsWithTimeRangeHm: boolean;
    /**
     * 상담 모바일앱 - 담당자로 지정된 채팅방의 신규 메시지를 수신한다는 가정 하에 알림을 받을 시작 시간
     * @format date
     * @example "2022-01-02T00:00:00.000Z"
     */
    counselorChatsStartedAtHm?: string;
    /**
     * 상담 모바일앱 - 담당자로 지정된 채팅방의 신규 메시지를 수신한다는 가정 하에 알림을 받을 종료 시간
     * @format date
     * @example "2022-01-02T10:00:00.000Z"
     */
    counselorChatsEndedAtHm?: string;
    /**
     * 상담 모바일앱 - 환자와의 채팅에서 참여자로 참여한 경우 푸시 알림을 수신할지 여부
     * @example true
     */
    participantChatsAllHm: boolean;
    /**
     * 상담 모바일앱 - 환자와의 채팅에서 참여자로 참여한 경우 정해진 시간대에만 모든 채팅 메세지 푸시 알림을 수신할지 여부
     * @example false
     */
    participantChatsWithTimeRangeHm: boolean;
    /**
     * 상담 모바일앱 - 환자와의 채팅에서 참여자로 참여한 경우 정해진 시간대에만 모든 채팅 메세지 푸시 알림을 수신한다는 가정 하에 알림을 받을 시작 시간
     * @format date
     * @example "2022-01-02T00:00:00.000Z"
     */
    participantChatsStartedAtHm?: string;
    /**
     * 상담 모바일앱 - 환자와의 채팅에서 참여자로 참여한 경우 정해진 시간대에만 모든 채팅 메세지 푸시 알림을 수신한다는 가정 하에 알림을 받을 종료 시간
     * @format date
     * @example "2022-01-02T10:00:00.000Z"
     */
    participantChatsEndedAtHm?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface HospitalMobileHospitalPushSettingUpdateHandlerBodyRequest {
  /**
   * 일렉트론 사용자의 병원 푸시 설정 ID
   * @example "639c31e489cce6e33c25ab6a"
   */
  _id: string;
  /**
   * 담당자로 지정된 채팅방의 신규 메시지를 수신할지 여부
   * @example false
   */
  onInChargeChat?: boolean;
  /**
   * 담당자로 지정된 채팅방에 대해서 특정 시간에만 신규 메시지를 수신할지 여부
   * @example false
   */
  hasTimeSettingForInChargeChat?: boolean;
  /**
   * 담당자로 지정된 채팅방의 신규 메시지를 수신한다는 가정 하에 알림을 받을 시작 시간
   * @format date
   * @example "2022-01-01T00:00:00.000Z"
   */
  inChargeChatStartedAt?: string;
  /**
   * 담당자로 지정된 채팅방의 신규 메시지를 수신한다는 가정 하에 알림을 받을 종료 시간
   * @format date
   * @example "2022-01-01T00:00:00.000Z"
   */
  inChargeChatEndedAt?: string;
  /**
   * 환자와의 채팅에서 참여자로 참여한 경우 푸시 알림을 수신할지 여부
   * @example true
   */
  onChatsAll?: boolean;
  /**
   * 환자와의 채팅에서 참여자로 참여한 경우 정해진 시간대에만 모든 채팅 메세지 푸시 알림을 수신할지 여부
   * @example false
   */
  onChatsDependsTime?: boolean;
  /**
   * 환자와의 채팅에서 참여자로 참여한 경우 정해진 시간대에만 모든 채팅 메세지 푸시 알림을 수신한다는 가정 하에 알림을 받을 시작 시간
   * @format date
   * @example "2022-01-01T00:00:00.000Z"
   */
  chatStartedAt?: string;
  /**
   * 환자와의 채팅에서 참여자로 참여한 경우 정해진 시간대에만 모든 채팅 메세지 푸시 알림을 수신한다는 가정 하에 알림을 받을 종료 시간
   * @format date
   * @example "2022-01-01T00:00:00.000Z"
   */
  chatEndedAt?: string;
  /**
   * 병원에서 원장을 포함한 직원 간의 채팅이 발생한 경우 모든 푸시 알림을 수신할지 여부
   * @example true
   */
  onManagerChatsAll?: boolean;
  /**
   * 병원에서 원장을 포함한 직원 간의 채팅이 발생한 경우 정해진 시간대에만 모든 푸시 알림을 수신할지 여부
   * @example false
   */
  onManagerChatsDependsTime?: boolean;
  /**
   * 병원에서 원장을 포함한 직원 간의 채팅이 발생한 경우 정해진 시간대에만 모든 푸시 알림을 수신한다는 가정 하에 알림을 받을 시작 시간
   * @format date
   * @example "2022-01-01T00:00:00.000Z"
   */
  managerChatStartedAt?: string;
  /**
   * 병원에서 원장을 포함한 직원 간의 채팅이 발생한 경우 정해진 시간대에만 모든 푸시 알림을 수신한다는 가정 하에 알림을 받을 종료 시간
   * @format date
   * @example "2022-01-01T00:00:00.000Z"
   */
  managerChatEndedAt?: string;
  /**
   * 예약이 생성되었을 때 푸시 알림을 수신할지 여부
   * @example true
   */
  onReservationNew?: boolean;
  /**
   * 예약이 변경되었을 때 푸시 알림을 수신할지 여부
   * @example true
   */
  onReservationChange?: boolean;
  /**
   * 예약이 취소되었을 때 푸시 알림을 수신할지 여부
   * @example true
   */
  onReservationCancel?: boolean;
  /**
   * 상담 모바일앱 - 담당자로 지정된 채팅방의 신규 메시지를 수신할지 여부
   * @example true
   */
  counselorChatsAllHm?: boolean;
  /**
   * 상담 모바일앱 - 담당자로 지정된 채팅방에 대해서 특정 시간에만 신규 메시지를 수신할지 여부
   * @example false
   */
  counselorChatsWithTimeRangeHm?: boolean;
  /**
   * 상담 모바일앱 - 담당자로 지정된 채팅방의 신규 메시지를 수신한다는 가정 하에 알림을 받을 시작 시간
   * @format date
   * @example "2022-01-02T00:00:00.000Z"
   */
  counselorChatsStartedAtHm?: string;
  /**
   * 상담 모바일앱 - 담당자로 지정된 채팅방의 신규 메시지를 수신한다는 가정 하에 알림을 받을 종료 시간
   * @format date
   * @example "2022-01-02T10:00:00.000Z"
   */
  counselorChatsEndedAtHm?: string;
  /**
   * 상담 모바일앱 - 환자와의 채팅에서 참여자로 참여한 경우 푸시 알림을 수신할지 여부
   * @example true
   */
  participantChatsAllHm?: boolean;
  /**
   * 상담 모바일앱 - 환자와의 채팅에서 참여자로 참여한 경우 정해진 시간대에만 모든 채팅 메세지 푸시 알림을 수신할지 여부
   * @example false
   */
  participantChatsWithTimeRangeHm?: boolean;
  /**
   * 상담 모바일앱 - 환자와의 채팅에서 참여자로 참여한 경우 정해진 시간대에만 모든 채팅 메세지 푸시 알림을 수신한다는 가정 하에 알림을 받을 시작 시간
   * @format date
   * @example "2022-01-02T00:00:00.000Z"
   */
  participantChatsStartedAtHm?: string;
  /**
   * 상담 모바일앱 - 환자와의 채팅에서 참여자로 참여한 경우 정해진 시간대에만 모든 채팅 메세지 푸시 알림을 수신한다는 가정 하에 알림을 받을 종료 시간
   * @format date
   * @example "2022-01-02T10:00:00.000Z"
   */
  participantChatsEndedAtHm?: string;
}

export interface HospitalMobileHospitalPushSettingUpdateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 특정 일렉트론 사용자의 병원 푸시 설정이 성공적으로 수정되었는지 여부
     * @example true
     */
    isUpdatedSuccess: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface HospitalsAccountsHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 전체 데이터 수 */
    totalCount: number;
    /** 전체 페이지 수 */
    totalPages: number;
    /** 현재 페이지 */
    currentPage: number;
    /** 페이지 당 조회되는 병원 직원 수 */
    limit: number;
    /** 다음 페이지 존재 여부 */
    hasNextPage: boolean;
    /** 병원 직원 정보 목록 */
    hworkers: {
      /** MongoDB Identifier */
      _id: string;
      /**
       * 유저의 타입.
       * 1000 = 환자
       * 2xxx = 병원 유저
       *  3xxx = 메디팔 유저
       */
      type: number;
      /** 유저가 보는 이름 */
      name: string;
      /** 실 이름 */
      realName: string;
      /** 로그인 시 사용되는 id */
      id: string;
      /** 매니저 유저의 경우, 소개글 */
      introduction: string;
      /** 매니저 계정의 경우, 경력. */
      career: string;
      /** 병원내 계정의 직/직책 */
      jobType: string;
      /** 권한 설정 ID */
      authorizationTypeID: string;
      /**
       * 마지막으로 로그인한 일시
       * @format date
       */
      lastLogin?: string;
      /**
       * 생성 일시
       * @format date
       */
      createdAt: string;
      /**
       * 마지막 수정 일시
       * @format date
       */
      updatedAt: string;
      /** 직원 권한 이름 */
      authorizationTypeName: string;
      /** 기본 상담사 여부 */
      isDefaultCounselor: boolean;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface HospitalsAccountsCountTuningHandlerBodyRequest {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 요청자 이름
   * @example "홍길동"
   */
  requesterName: string;
  /**
   * 요청자 연락처
   * @example "010-1234-5678"
   */
  requesterContact: string;
  /**
   * 추가 요청할 병원 직원 계정 수
   * @example 10
   */
  requestedAccountCount: number;
}

export interface HospitalsAccountsCountTuningHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 계정 조정 요청 성공 여부 */
    isUpdatedSuccess: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ApiHospitalsElFindParams {
  /** 병원ID */
  _id?: string;
}

export interface ApiHospitalsElFindData {
  /** 응답 코드 */
  code?: number;
  data: Hospital[];
  /** 응답 메시지 */
  message?: string;
}

export type ApiHospitalsElUpdateData = ApiResponse & {
  data: HospitalRepresentImage;
};

export type ApiHospitalsElUpdateSmslogoimageData = any;

export interface ApiHospitalsElFindAddressParams {
  /** 검색 키워드 */
  keyword?: string;
  /** 현재 페이지 */
  currentPage?: string;
  /** 한 페이지에 출력될 row 갯수 */
  countPerPage?: string;
}

export type ApiHospitalsElFindAddressData = ApiResponse & {
  data: {
    common?: CommonResponse;
    juso?: Juso[];
  };
};

export interface ApiHospitalsElFindDoctorsParams {
  /** 병원ID */
  hospitalID: string;
}

export type ApiHospitalsElFindDoctorsData = ApiResponse & {
  data: UserFindStats[];
};

export interface ApiHospitalsElFindUsersParams {
  /** 병원ID */
  hospitalID: string;
}

export type ApiHospitalsElFindUsersData = ApiResponseAbnormal01;

export interface HospitalMFindOneHandlerParams {
  hospitalID: string;
}

export type HospitalMFindOneHandlerData = HospitalMFindOneHandlerResponse;

export interface HospitalMFindDoctorsHandlerParams {
  hospitalID: string;
}

export type HospitalMFindDoctorsHandlerData = HospitalMFindDoctorsHandlerResponse;

export interface ApiHospitalsMFindAfterhoursPopupParams {
  /** (required) 병원 ID */
  hospitalID?: string;
}

export type ApiHospitalsMFindAfterhoursPopupData = any;

export interface ApiHospitalsHmFindParams {
  /** 병원ID */
  _id?: string;
}

export interface ApiHospitalsHmFindData {
  /** 응답 코드 */
  code?: number;
  data: Hospital[];
  /** 응답 메시지 */
  message?: string;
}

export interface ApiHospitalsAccountsElFindParams {
  /** 병원 ID */
  hospitalID?: any;
  /** 유저 ID */
  userID?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
  /** ALL 기본 전체, NORMAL 다중 병원 관리 계정 제외, MSO 다중 병원 관리 계정만 */
  accountType?: "ALL" | "NORMAL" | "MSO";
}

export type ApiHospitalsAccountsElFindData = ApiResponse & {
  data: UserHServicePhotoAuthorizationType[];
};

export type ApiHospitalsAccountsElCreateData = ApiResponse & {
  data: {
    /**
     * 계정 생성 성공 여부
     * @example true
     */
    isCreatedSucess: boolean;
  };
};

export type ApiHospitalsAccountsElUpdateData = ApiResponse & {
  data: {
    /**
     * 계정 수정 성공 여부
     * @example true
     */
    isUpdatedSuccess: boolean;
  };
};

export type ApiHospitalsAccountsElIdcheckData = ApiResponse & {
  /** 중복 여부 (true=중복되지 않음, false=중복됨) */
  data: boolean;
};

export type ApiHospitalsAccountsElRemoveData = ApiResponse & {
  data: {
    /**
     * 계정 삭제 성공 여부
     * @example true
     */
    isDeletedSucess: boolean;
  };
};

export interface ApiHospitalsAuthorizationTypeElFindParams {
  /** 병원 ID */
  hospitalID: any;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: 1 | -1;
}

export type ApiHospitalsAuthorizationTypeElFindData = ApiResponse & {
  data: AuthorizationTypeForV3[];
};

export type ApiHospitalsAuthorizationTypeElUpdateData = ApiResponse & {
  data: AuthorizationType;
};

export type HospitalNameControllerGetHospitalNamesData = HospitalNameControllerGetHospitalNamesResponse;

export type HospitalAccountControllerCreateAccountData = HospitalAccountControllerCreateAccountResponse;

export interface HospitalsBackgroundJobsHandlerParams {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
}

export type HospitalsBackgroundJobsHandlerData = HospitalsBackgroundJobsHandlerResponse;

export interface SingleHospitalPushSettingHandlerParams {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 사용자 ID
   * @example "613aa681cb516152eed8fdb3"
   */
  userID: string;
}

export type SingleHospitalPushSettingHandlerData = SingleHospitalPushSettingHandlerResponse;

export type HospitalPushSettingUpdateHandlerData = HospitalPushSettingUpdateHandlerResponse;

export interface HospitalMobileSingleHospitalPushSettingHandlerParams {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 사용자 ID
   * @example "613aa681cb516152eed8fdb3"
   */
  userID: string;
}

export type HospitalMobileSingleHospitalPushSettingHandlerData = HospitalMobileSingleHospitalPushSettingHandlerResponse;

export type HospitalMobileHospitalPushSettingUpdateHandlerData = HospitalMobileHospitalPushSettingUpdateHandlerResponse;

export interface HospitalsAccountsHandlerParams {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /** 조회 대상 병원 직원 ID */
  userID?: string;
  /**
   * 조회할 페이지 번호
   * @example 1
   */
  page?: number;
  /**
   * 가져올 데이터 수
   * @example 10
   */
  limit?: number;
}

export type HospitalsAccountsHandlerData = HospitalsAccountsHandlerResponse;

export type HospitalsAccountsCountTuningHandlerData = HospitalsAccountsCountTuningHandlerResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * No description
     *
     * @tags V3-Hospital
     * @name ApiHospitalsElFind
     * @summary 병원정보 설정(Hospital) 조회
     * @request GET:/v3/api/hospitals/el/find
     * @secure
     * @response `200` `ApiHospitalsElFindData` 병원 정보 목록
     */
    apiHospitalsElFind: (query: ApiHospitalsElFindParams, params: RequestParams = {}) =>
      this.request<ApiHospitalsElFindData, any>({
        path: `/v3/api/hospitals/el/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Hospital
     * @name ApiHospitalsElUpdate
     * @summary 병원정보(Hospital) 수정
     * @request POST:/v3/api/hospitals/el/update
     * @secure
     * @response `200` `ApiHospitalsElUpdateData` \{Hospital\} Hospital 컬렉션 객체
     */
    apiHospitalsElUpdate: (
      data: {
        /** Hospital Object ID */
        _id?: string;
        /** 병원 별 언어와 국가 설정. 예: ko-KR (한국어, 대한민국), en-US (영어, 미국), vn-VN (베트남어, 베트남) */
        locale?: string;
        /** 병원 별 시간대 설정. 예: Asia/Seoul (서울), Asia/Ho_Chi_Minh (호치민) */
        timezone?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHospitalsElUpdateData, any>({
        path: `/v3/api/hospitals/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Hospital
     * @name ApiHospitalsElUpdateSmslogoimage
     * @summary 최초유입 SMS 발송시 사용될 병원 로고 설정 업데이트
     * @request POST:/v3/api/hospitals/el/update/smslogoimage
     * @secure
     * @response `200` `ApiHospitalsElUpdateSmslogoimageData` reseponse of login
     */
    apiHospitalsElUpdateSmslogoimage: (
      data: {
        hospitalID?: string;
        smsLogoImage?: string;
        isUsingLogo?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHospitalsElUpdateSmslogoimageData, any>({
        path: `/v3/api/hospitals/el/update/smslogoimage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Hospital
     * @name ApiHospitalsElFindAddress
     * @summary 병원 주소정보 조회
     * @request GET:/v3/api/hospitals/el/find/address
     * @secure
     * @response `200` `ApiHospitalsElFindAddressData` 주소 검색 결과
     */
    apiHospitalsElFindAddress: (query: ApiHospitalsElFindAddressParams, params: RequestParams = {}) =>
      this.request<ApiHospitalsElFindAddressData, any>({
        path: `/v3/api/hospitals/el/find/address`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Hospital
     * @name ApiHospitalsElFindDoctors
     * @summary 병원내 의사정보 조회
     * @request GET:/v3/api/hospitals/el/find/doctors
     * @secure
     * @response `200` `ApiHospitalsElFindDoctorsData` 병원 내 의사 정보 조회 성공
     */
    apiHospitalsElFindDoctors: (query: ApiHospitalsElFindDoctorsParams, params: RequestParams = {}) =>
      this.request<ApiHospitalsElFindDoctorsData, any>({
        path: `/v3/api/hospitals/el/find/doctors`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Hospital
     * @name ApiHospitalsElFindUsers
     * @summary 병원내 유저정보 조회
     * @request GET:/v3/api/hospitals/el/find/users
     * @secure
     * @response `200` `ApiHospitalsElFindUsersData` 병원 내 유저 정보 조회 성공
     */
    apiHospitalsElFindUsers: (query: ApiHospitalsElFindUsersParams, params: RequestParams = {}) =>
      this.request<ApiHospitalsElFindUsersData, any>({
        path: `/v3/api/hospitals/el/find/users`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 정보 조회
     *
     * @tags V3-Hospital
     * @name HospitalMFindOneHandler
     * @summary 병원 정보 조회 : ts
     * @request GET:/v3/api/hospitals/m/find/one
     * @secure
     * @response `200` `HospitalMFindOneHandlerData` success
     */
    hospitalMFindOneHandler: (query: HospitalMFindOneHandlerParams, params: RequestParams = {}) =>
      this.request<HospitalMFindOneHandlerData, any>({
        path: `/v3/api/hospitals/m/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 내 의사 정보 조회
     *
     * @tags V3-Hospital
     * @name HospitalMFindDoctorsHandler
     * @summary 병원 내 의사 정보 조회 : ts
     * @request GET:/v3/api/hospitals/m/find/doctors
     * @secure
     * @response `200` `HospitalMFindDoctorsHandlerData` success
     */
    hospitalMFindDoctorsHandler: (query: HospitalMFindDoctorsHandlerParams, params: RequestParams = {}) =>
      this.request<HospitalMFindDoctorsHandlerData, any>({
        path: `/v3/api/hospitals/m/find/doctors`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Hospital
     * @name ApiHospitalsMFindAfterhoursPopup
     * @summary 병원별 애프터닥 운영시간 종료 후 환자 채팅 시 팝업 표시 HTML 파일 (모바일)
     * @request GET:/v3/api/hospitals/m/find/afterhours/popup
     * @secure
     * @response `200` `ApiHospitalsMFindAfterhoursPopupData` HTML File Response
     */
    apiHospitalsMFindAfterhoursPopup: (query: ApiHospitalsMFindAfterhoursPopupParams, params: RequestParams = {}) =>
      this.request<ApiHospitalsMFindAfterhoursPopupData, any>({
        path: `/v3/api/hospitals/m/find/afterhours/popup`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Hospital
     * @name ApiHospitalsHmFind
     * @summary 병원 상담 모바일 앱 - 병원정보 설정(Hospital) 조회
     * @request GET:/v3/api/hospitals/hm/find
     * @secure
     * @response `200` `ApiHospitalsHmFindData` 병원 정보 목록
     */
    apiHospitalsHmFind: (query: ApiHospitalsHmFindParams, params: RequestParams = {}) =>
      this.request<ApiHospitalsHmFindData, any>({
        path: `/v3/api/hospitals/hm/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 내 계정 조회.
     *
     * @tags V3-HospitalAccount
     * @name ApiHospitalsAccountsElFind
     * @summary 병원 내 계정 조회
     * @request GET:/v3/api/hospitals/accounts/el/find
     * @secure
     * @response `200` `ApiHospitalsAccountsElFindData` 병원에 소속된 계정 조회 성공
     */
    apiHospitalsAccountsElFind: (query: ApiHospitalsAccountsElFindParams, params: RequestParams = {}) =>
      this.request<ApiHospitalsAccountsElFindData, any>({
        path: `/v3/api/hospitals/accounts/el/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 계정 생성
     *
     * @tags V3-HospitalAccount
     * @name ApiHospitalsAccountsElCreate
     * @summary 병원 계정 생성
     * @request POST:/v3/api/hospitals/accounts/el/create
     * @secure
     * @response `200` `ApiHospitalsAccountsElCreateData` 병원 계정 생성 성공
     */
    apiHospitalsAccountsElCreate: (
      data: {
        /**
         * 병원 ID
         * @example "613aa681cb516152eed8fdb3"
         */
        hospitalID: string;
        /** 병원 계정 ID. 최소 3글자 이상, 최대 25글자 이하 */
        id: string;
        /** 병원 계정 비밀번호. 최소 3글자 이상, 최대 25글자 이하 */
        password: string;
        /**
         * 권한 유형. 마스터, 관리자, 직원, 직원 2, 직원 3 중에서만 선택 가능
         * @default "직원"
         */
        authorizationType: "마스터" | "관리자" | "직원" | "직원 2" | "직원 3";
        /**
         * 직책/직급. 직접 입력 가능. 대표원장, 팀장, 실장, 직원, 상담실장, 치료사 등
         * @example "팀장"
         */
        jobType: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHospitalsAccountsElCreateData, any>({
        path: `/v3/api/hospitals/accounts/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HospitalAccount
     * @name ApiHospitalsAccountsElUpdate
     * @summary 병원 내 계정 수정
     * @request POST:/v3/api/hospitals/accounts/el/update
     * @secure
     * @response `200` `ApiHospitalsAccountsElUpdateData` 병원 내 계정 수정 성공
     */
    apiHospitalsAccountsElUpdate: (
      data: {
        /** 수정하고자 하는 병원 계정 Object ID */
        _id: string;
        /**
         * 병원 ID
         * @example "63d7bafc1374672f7c407efd"
         */
        hospitalID: string;
        /**
         * 병원 직원 계정 휴대폰 번호
         * @example 1012345678
         */
        phone?: string;
        /** 병원 계정 이름 */
        name?: string;
        /** 병원 직원 계정 실명 - 일렉트론 상에서 병원 내에서 타 직원들에게 보여지는 이름 */
        realName?: string;
        /** 병원 계정 ID. 최소 3글자 이상, 최대 25글자 이하 */
        id?: string;
        /** 병원 계정 비밀번호. 최소 3글자 이상, 최대 25글자 이하 */
        password?: string;
        /** 권한 유형. 마스터, 관리자, 직원, 직원 2, 직원 3 중에서만 선택 가능 */
        authorizationType?: "마스터" | "관리자" | "직원" | "직원 2" | "직원 3";
        /** 직책/직급. 직접 입력 가능. 대표원장, 팀장, 실장, 직원, 상담실장, 치료사 등 */
        jobType?: string;
        /** 기본 상담사로 지정 여부 */
        isDefaultCounselor?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHospitalsAccountsElUpdateData, any>({
        path: `/v3/api/hospitals/accounts/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 내 계정 ID 중복 확인
     *
     * @tags V3-HospitalAccount
     * @name ApiHospitalsAccountsElIdcheck
     * @summary 병원 내 계정 ID 중복 확인
     * @request POST:/v3/api/hospitals/accounts/el/idcheck
     * @secure
     * @response `200` `ApiHospitalsAccountsElIdcheckData` ID 중복 확인 성공 (중복되지 않음)
     */
    apiHospitalsAccountsElIdcheck: (
      data: {
        /** 수정하고자 하는 유저 Object ID */
        _id?: string;
        /** 중복 체크를 진행하고자 하는 ID */
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHospitalsAccountsElIdcheckData, any>({
        path: `/v3/api/hospitals/accounts/el/idcheck`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 내 계정 삭제
     *
     * @tags V3-HospitalAccount
     * @name ApiHospitalsAccountsElRemove
     * @summary 병원 내 계정 삭제
     * @request POST:/v3/api/hospitals/accounts/el/remove
     * @secure
     * @response `200` `ApiHospitalsAccountsElRemoveData` 병원 내 계정 삭제 성공
     */
    apiHospitalsAccountsElRemove: (
      data: {
        /**
         * 삭제하고자 하는 유저 Object ID
         * @example "6564308cfccee4a776451fcc"
         */
        _id: string;
        /**
         * 병원 ID
         * @example "63d7bafc1374672f7c407efd"
         */
        hospitalID: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHospitalsAccountsElRemoveData, any>({
        path: `/v3/api/hospitals/accounts/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 내 권한 목록 조회.
     *
     * @tags V3-HospitalAuthorizationType
     * @name ApiHospitalsAuthorizationTypeElFind
     * @summary 병원 내 권한 목록
     * @request GET:/v3/api/hospitals/authorization-type/el/find
     * @secure
     * @response `200` `ApiHospitalsAuthorizationTypeElFindData` 병원 내 권한 목록 조회 성공
     */
    apiHospitalsAuthorizationTypeElFind: (
      query: ApiHospitalsAuthorizationTypeElFindParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiHospitalsAuthorizationTypeElFindData, any>({
        path: `/v3/api/hospitals/authorization-type/el/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HospitalAuthorizationType
     * @name ApiHospitalsAuthorizationTypeElUpdate
     * @summary 권한설정(AuthorizationType) 수정
     * @request POST:/v3/api/hospitals/authorization-type/el/update
     * @secure
     * @response `200` `ApiHospitalsAuthorizationTypeElUpdateData` 권한설정 수정 성공
     */
    apiHospitalsAuthorizationTypeElUpdate: (
      data: AuthorizationType & {
        createdAt?: string;
        updatedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHospitalsAuthorizationTypeElUpdateData, any>({
        path: `/v3/api/hospitals/authorization-type/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 ID 목록으로 병원명({ [id]: shortName||name }) 맵을 조회합니다.
     *
     * @tags V3-Hospital
     * @name HospitalNameControllerGetHospitalNames
     * @summary 병원명 일괄 조회
     * @request POST:/v3/api/hospitals/names
     * @secure
     * @response `200` `HospitalNameControllerGetHospitalNamesData` success
     */
    hospitalNameControllerGetHospitalNames: (
      data: HospitalNameControllerGetHospitalNamesBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<HospitalNameControllerGetHospitalNamesData, any>({
        path: `/v3/api/hospitals/names`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HospitalAccount
     * @name HospitalAccountControllerCreateAccount
     * @summary 병원 계정 생성
     * @request POST:/v3/api/hospitals/accounts
     * @secure
     * @response `200` `HospitalAccountControllerCreateAccountData` success
     */
    hospitalAccountControllerCreateAccount: (
      data: HospitalAccountControllerCreateAccountBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<HospitalAccountControllerCreateAccountData, any>({
        path: `/v3/api/hospitals/accounts`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 별 백그라운드에서 수행되고 있는 작업 목록을 조회합니다.
     *
     * @tags V3-Hospital
     * @name HospitalsBackgroundJobsHandler
     * @summary 병원 별 백그라운드 수행 작업 목록 조회
     * @request GET:/v3/api/hospitals/el/background/jobs
     * @secure
     * @response `200` `HospitalsBackgroundJobsHandlerData` success
     */
    hospitalsBackgroundJobsHandler: (query: HospitalsBackgroundJobsHandlerParams, params: RequestParams = {}) =>
      this.request<HospitalsBackgroundJobsHandlerData, any>({
        path: `/v3/api/hospitals/el/background/jobs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 병원 직원의 푸시 설정을 조회합니다.
     *
     * @tags V3-HospitalPushSettings
     * @name SingleHospitalPushSettingHandler
     * @summary 특정 병원 직원의 푸시 설정 조회
     * @request GET:/v3/api/hospitals/push-settings/el/single
     * @secure
     * @response `200` `SingleHospitalPushSettingHandlerData` success
     */
    singleHospitalPushSettingHandler: (query: SingleHospitalPushSettingHandlerParams, params: RequestParams = {}) =>
      this.request<SingleHospitalPushSettingHandlerData, any>({
        path: `/v3/api/hospitals/push-settings/el/single`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 병원 직원의 푸시 설정을 수정합니다.
     *
     * @tags V3-HospitalPushSettings
     * @name HospitalPushSettingUpdateHandler
     * @summary 특정 병원 직원의 푸시 설정 수정
     * @request PUT:/v3/api/hospitals/push-settings/el/single
     * @secure
     * @response `200` `HospitalPushSettingUpdateHandlerData` success
     */
    hospitalPushSettingUpdateHandler: (data: HospitalPushSettingUpdateHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<HospitalPushSettingUpdateHandlerData, any>({
        path: `/v3/api/hospitals/push-settings/el/single`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 상담 모바일 앱 - 특정 병원 직원의 푸시 설정을 조회합니다.
     *
     * @tags V3-HospitalPushSettings
     * @name HospitalMobileSingleHospitalPushSettingHandler
     * @summary 상담 모바일 앱 - 특정 병원 직원의 푸시 설정 조회
     * @request GET:/v3/api/hospitals/push-settings/hm/single
     * @secure
     * @response `200` `HospitalMobileSingleHospitalPushSettingHandlerData` success
     */
    hospitalMobileSingleHospitalPushSettingHandler: (
      query: HospitalMobileSingleHospitalPushSettingHandlerParams,
      params: RequestParams = {},
    ) =>
      this.request<HospitalMobileSingleHospitalPushSettingHandlerData, any>({
        path: `/v3/api/hospitals/push-settings/hm/single`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 상담 모바일 앱 - 특정 병원 직원의 푸시 설정을 수정합니다.
     *
     * @tags V3-HospitalPushSettings
     * @name HospitalMobileHospitalPushSettingUpdateHandler
     * @summary 상담 모바일 앱 - 특정 병원 직원의 푸시 설정 수정
     * @request PUT:/v3/api/hospitals/push-settings/hm/single
     * @secure
     * @response `200` `HospitalMobileHospitalPushSettingUpdateHandlerData` success
     */
    hospitalMobileHospitalPushSettingUpdateHandler: (
      data: HospitalMobileHospitalPushSettingUpdateHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<HospitalMobileHospitalPushSettingUpdateHandlerData, any>({
        path: `/v3/api/hospitals/push-settings/hm/single`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 병원의 직원 계정들을 조회합니다.
     *
     * @tags V3-HospitalAccount
     * @name HospitalsAccountsHandler
     * @summary 특정 병원의 직원 계정들 조회
     * @request GET:/v3/api/hospitals/accounts/el/find/all
     * @secure
     * @response `200` `HospitalsAccountsHandlerData` success
     */
    hospitalsAccountsHandler: (query: HospitalsAccountsHandlerParams, params: RequestParams = {}) =>
      this.request<HospitalsAccountsHandlerData, any>({
        path: `/v3/api/hospitals/accounts/el/find/all`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 병원에서 생성 가능한 직원 계정 수 조정을 요청합니다.
     *
     * @tags V3-HospitalAccount
     * @name HospitalsAccountsCountTuningHandler
     * @summary 특정 병원에서 생성 가능한 직원 계정 수 조정 요청
     * @request PATCH:/v3/api/hospitals/accounts/el/creatable-count
     * @secure
     * @response `200` `HospitalsAccountsCountTuningHandlerData` success
     */
    hospitalsAccountsCountTuningHandler: (
      data: HospitalsAccountsCountTuningHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<HospitalsAccountsCountTuningHandlerData, any>({
        path: `/v3/api/hospitals/accounts/el/creatable-count`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
